import { isDate } from 'date-fns';
import _ from 'lodash';
import { reverseOffset } from './functions';

// recursive function that iterates through an object, restores the actual array values (rather than the dif summary), and sanitizes dates

export default function sanitizeDiff(obj, values) {
  const { transform, isObject, isUndefined, get } = _;

  const deepTransform = (obj, iterator, currentPath = []) => {
    return transform(obj, (acc, val, key) => {
      const newPath = currentPath.concat(key);
      const [k, v, skip] = iterator(key, val, newPath); // pass the newPath to the iterator

      if (isUndefined(k) || isUndefined(v)) {
        return;
      }

      acc[k] = isObject(v) && !isDate(v) && !skip ? deepTransform(v, iterator, newPath) : v;
    });
  };

  const iterator = (key, value, path) => {
    if (isDate(value)) {
      const newValue = reverseOffset(value);
      return [key, newValue];
    }

    if (isUndefined(value)) return [key, ''];

    if (isObject(value)) {
      if (Object.keys(value).some((r) => !isNaN(r))) {
        const skip = true;
        const address = path.join('.');
        const arr = get(values, address);
        return [key, arr, skip];
      }
    }

    return [key, value];
  };

  const newObj = deepTransform(obj, iterator);

  return newObj;
}
